import PropTypes from 'prop-types';
import React from 'react';
import TableHeader from './tableHeader';
import TableRow from './tableRow';

const AppointmentsListDay = ({ appointments }) => (
  <div className="c-appointments__item">
    <div className="c-appointments-table">
      <TableHeader />
      {
        appointments.map((appointment, idx) => (
          <div
            key={appointment.id}
            className="c-appointment-details-wrapper"
            data-automation-id={`container:appointment:${appointment.id}`}
          >
            <TableRow appointment={appointment} counter={idx + 1} />
          </div>
        ))
      }
    </div>
  </div>
);

AppointmentsListDay.propTypes = {
  appointments: PropTypes.arrayOf(PropTypes.object).isRequired,
};

export default AppointmentsListDay;
